import { URLData } from 'OK/URLData';

export const PROTOCOL_SCHEMAS: string[] = ['http://', 'https://'];

export function extractPathAndQueryFromUrl(url: string): string {
  const schema: string = extractSchema(url);

  if (schema) {
    const pathStart = url.indexOf('/', schema.length);
    return pathStart === -1 ? '/' : url.substring(pathStart);
  }

  return url;
}

export function extractSchema(url: string): string {
  let schema: string = '';
  for (let i = 0; i < PROTOCOL_SCHEMAS.length; i++) {
    const p: string = PROTOCOL_SCHEMAS[i];

    if (url.toLowerCase().startsWith(p)) {
      schema = p;
      break;
    }
  }

  return schema;
}

export function parseUrl(url: string, decode = true): URLData {
  const protocol = extractSchema(url);
  const pathAndQuery = extractPathAndQueryFromUrl(url);
  const protocolEnd = protocol.length || 0;
  const hostEnd = url.indexOf('/', protocolEnd);
  const host = url.substring(protocolEnd, hostEnd < 0 ? url.length : hostEnd);

  let path: string;
  let query: string;
  const k = pathAndQuery.indexOf('?');
  if (k < 0) {
    path = pathAndQuery;
    query = '';
  } else {
    path = pathAndQuery.substring(0, k);
    query = pathAndQuery.substring(k + 1);
  }

  const parts: string[] = path.split('/').reduce<string[]>((result, item) => {
    if (item) {
      let part = item.toLowerCase();

      if (decode) {
        part = decodeURIComponent(item);
      }

      result.push(part);
    }

    return result;
  }, []);

  const params = new Map<string, string>();
  query.split('&').forEach((urlParam) => {
    if (!urlParam) {
      return;
    }

    const index = urlParam.indexOf('=');
    if (index === -1) {
      return;
    }

    const key = urlParam.substring(0, index);
    let value = urlParam.substring(index + 1);

    if (decode) {
      value = decodeURIComponent(value.replace(/\+/g, '%20'));
    }

    params.set(key.toLowerCase(), value);
  });

  return new URLData(url, protocol, host, path, query, parts, params);
}

/**
 * Достаём параметры из ссылки.
 * @param url - полная ссылка вида https://www.example.com/sample?query=1&text=text&page=43
 */
export function getSearchParamsFromUrl(url: string): URLSearchParams {
  const params = url.substring(url.indexOf('?') + 1);
  return new URLSearchParams(params);
}

export function isNumber(value: string): boolean {
  return !isNaN(parseFloat(value)) && isFinite(Number(value));
}
